import { useEffect } from "react";

/**
 * Mantém a sessão em sincronia entre abas: o evento `storage` dispara quando
 * outra aba faz login/logout, e o callback reidrata o estado a partir do
 * localStorage atualizado.
 */
export function useCrossTabSync(onExternalChange: () => void): void {
  useEffect(() => {
    window.addEventListener("storage", onExternalChange);
    return () => window.removeEventListener("storage", onExternalChange);
  }, [onExternalChange]);
}
